import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import EditIcon from '../../css/images/icon-Table-Edit.svg';

const EditButton = ({ basePath = '', record = {}, type, label = 'Edit' }) => {
    return (
        <Link 
            className="btn-icon x-table-icon" 
            title={label}
            to={`${basePath}/${type}/${record.cell.row.original.id}/edit`}
        >
            <img src={EditIcon} alt="Edit Table Icon"/>
        </Link>
    );
};

EditButton.propTypes = {
    /**
     * Currently not used
     */
    basePath: PropTypes.string,
    /**
     * The Link to the data repo in which the file is to be found
     */
    type: PropTypes.string,
    /**
     * The record from which the filepath for editing is extracted. (record.cell.row.original_id)
     */
    record: PropTypes.object,
    /**
     * The label displayed in browser tooltips
     */
    label: PropTypes.string,
};

export default EditButton;